const initialState = {
  schTp: "",
  mainSide: "",
  loading: false,
};

export const LOADING = "LOADING";
export const loadingAction = (data) => ({
  type: LOADING,
  payload: data,
});

export const LOAD_LEFT = "LOAD_LEFT";
export const loadLeftAction = (data) => ({
  type: LOAD_LEFT,
  payload: data,
});

export const LOAD_LEFT_SUCCESS = "LOAD_LEFT_SUCCESS";
export const loadDataSuccessAction = (list) => ({
  type: LOAD_LEFT_SUCCESS,
  payload: list,
});

export default function leftReducer(state = initialState, action) {
  const { type, payload, error } = action;
  console.log("payload", payload);
  switch (type) {
    case LOADING:
      return {
        ...state,
        loading: payload,
      };
    case LOAD_LEFT:
      return {
        ...state,
        schTp: payload,
      };
    case LOAD_LEFT_SUCCESS:
      return {
        ...state,
        mainSide: payload,
      };
    default:
      return state;
  }
}
